import { RadioGroup } from "@headlessui/react";
import { FormCardContainer } from "./form.primitives";
import { EllipseMenuIcon } from "../../assets/icons/ellipse.svg";

interface RadioOption {
  name: string;
  icon?: React.ReactNode; // Optional icon to be displayed on the right
}

interface RadioButtonsProps {
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
}

export const RadioButtons: React.FC<RadioButtonsProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      className="flex flex-col gap-5"
    >
      {options.map((option) => (
        <RadioGroup.Option key={option.name} value={option.name}>
          {({ checked }) => (
            <RadioGroupCircle
              checked={checked}
              text={option.name}
              icon={option.icon}
            />
          )}
        </RadioGroup.Option>
      ))}
    </RadioGroup>
  );
};

export const RadioGroupCircle: React.FC<{
  checked: boolean;
  text: string;
  icon?: React.ReactNode;
}> = ({ checked, text, icon }) => {
  return (
    <div className={`flex justify-between items-center gap-3 cursor-pointer`}>
      <div className="flex">
        {checked ? <CheckedCircleIcon /> : <UncheckedCircleIcon />}
        <div className="ml-2 text-vid-black-900 text-sm">{text}</div>
      </div>
      {icon && <div className="flex items-center">{icon}</div>}
    </div>
  );
};

export const FormRadioCard: React.FC<{
  radioProps: RadioButtonsProps;
  title: string;
  optionsMenu?: React.ReactNode;
}> = ({ radioProps, title, optionsMenu }) => {
  return (
    <FormCardContainer>
      <div className="flex items-center justify-between">
        <span className="text-vid-purple font-sans font-light text-sm">
          {title}
        </span>
        {optionsMenu && (
          <div>
            <EllipseMenuIcon size={3} fill={"gray"} />
          </div>
        )}
      </div>
      <div className="mt-2 flex-1 flex flex-col font-sans text-sm font-light">
        <RadioButtons {...radioProps} />
      </div>
    </FormCardContainer>
  );
};

function UncheckedCircleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      fill="none"
      viewBox="0 0 18 19"
    >
      <circle cx="9" cy="9.438" r="8.5" fill="#fff" stroke="#1D1626"></circle>
    </svg>
  );
}

function CheckedCircleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      fill="none"
      viewBox="0 0 18 19"
    >
      <circle cx="9" cy="9.438" r="8.5" fill="#fff" stroke="#1D1626"></circle>
      <circle
        cx="9"
        cy="9.438"
        r="5.5"
        fill="#690DFF"
        stroke="#690DFF"
      ></circle>
    </svg>
  );
}
